import { ICategory, ICategoryItemDict } from '../classes/Model/Category';
import { FilterCategoryName } from '../constants';

export function buildCategory(
    filterCategoryName: FilterCategoryName,
    categoryItemDict: ICategoryItemDict
): ICategory {
    return {
        handle: filterCategoryName,
        name: filterCategoryName,
        categories: categoryItemDict,
    };
}
